import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import StaticVideo from './staticVideo';
import SwitchTV from './switchTV';

class Phtv extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        channelIndex: 0,
    };

    channelIndexHanle = value => {
        this.setState({
            channelIndex: value,
        });
    };

    render() {
        const { content } = this.props;
        const { channelIndex } = this.state;
        const sourceUrl = content[channelIndex]?.videoUrl;
        const gotoUrl = content[channelIndex]?.url;
        const posterUrl = content[channelIndex]?.poster;
        const videoStaticPic = content[channelIndex]?.videoStaticPic;

        return (
            <div className={styles.phtvBox}>
                <StaticVideo
                    sourceUrl={sourceUrl}
                    gotoUrl={gotoUrl}
                    posterUrl={posterUrl}
                    videoStaticPic={videoStaticPic}
                />
                <SwitchTV channelChange={this.channelIndexHanle} phtvVideoInfo={content} />
            </div>
        );
    }
}

export default errorBoundary(Phtv);
